export const contactsData = {
    email: 'sravanvijayakumar97@gmail.com',
    phone: '+91 7306619179',
    address: 'Palakkad, Kerala, India - 678555',
    sheetAPI: ''
}